/*!

=========================================================
* Paper Kit React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

// core components

function Trailers() {
  return (
    <>
      <div
        className="section section-image section-login section-dark"
        style={{
          backgroundImage: "url(" + require("../../assets/img/Index/Portal.jpg") + ")",
        }}
      >
        <div className="section section-dark section-dark-transparent">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto text-center" md="8">
                <h2 className="title">Trailers</h2>
                <hr style={{ clear: 'both' }} />
                <p className="description">
                  Take a quick look at what the new version of MKDOTE looks like with its main new features. Or watch the opening cinematic.
              </p>
                <br />
              </Col>
            </Row>
          </Container>
          <Container>
            <Row>
              <Col md="6">
                <div className="embed-responsive embed-responsive-16by9">
                  <iframe title="trailer" className="embed-responsive-item" src="https://www.youtube.com/embed/FJtvt5pzy7o" allowFullScreen ></iframe>
                </div>
                <br />
              </Col>
              <Col md="6">
                <div className="embed-responsive embed-responsive-16by9">
                  <iframe title="intro" className="embed-responsive-item" src="https://www.youtube.com/embed/K81dlZn7K7s" allowFullScreen ></iframe>
                </div>
                <br />
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default Trailers;
